import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export class BackButton extends React.Component {
  render() {
    return (
      <button type="button" className="btn btn-primary my-1" onClick={this.props.onClick}>
        <span className="fa-solid fa-chevron-left me-1" />
        <FormattedMessage { ...this.props.buttonName } />
      </button>
    );
  }
}

BackButton.propTypes = {
  buttonName: PropTypes.object,
  onClick: PropTypes.func,
};
